import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { CatalogItemsCount, CatalogItemsCountSkeleton } from "@l2r-front/l2r-ui"

import { useHorizontalSigningStateContext } from "../../contexts/HorizontalSigningContext"
import { useHorizontalSigningCategoriesStats } from "../../hooks/queries/horizontalSigning/useHorizontalSigningCategoriesStats"
import { useHorizontalSignTypes } from "../../hooks/queries/horizontalSigning/useHorizontalSignTypes"

export function HorizontalSignsCount(props) {

    const {
        className,
        displayTotalCount,
        isMainCount,
        signType,
    } = props

    const { road } = useParams()
    const { filters } = useHorizontalSigningStateContext()

    const apiFilters = {
        ...(filters?.conditions?.length && { condition: filters?.conditions }),
        ...(filters?.tags?.length && { tags: filters.tags.join(",") }),
        ...(road && { linear_location_road: road }),
    }

    const { data: dataWithFilters,
        isError: dataWithFiltersError,
        isLoading: dataWithFiltersLoading,
    } = useHorizontalSigningCategoriesStats({ ...apiFilters })

    const {
        data: dataWithoutConditionFilters,
        isError: dataWithoutConditionFiltersError,
        isLoading: dataWithoutConditionFiltersLoading,
    } = useHorizontalSigningCategoriesStats({ ...(road && { linear_location_road: road }) })

    const {
        data: horizontalSignTypes,
        isError: isErrorHorizontalSignTypes,
        isLoading: isLoadingHorizontalSignTypes,
    } = useHorizontalSignTypes()

    const calculatedCount = useMemo(() => {
        if (signType) {
            return dataWithFilters?.count[signType] || 0
        } else if (dataWithFilters && horizontalSignTypes) {
            return horizontalSignTypes.reduce((acc, verticalSignType) => {
                return acc + dataWithFilters.count[verticalSignType.code]
            }, 0)
        } else {
            return 0
        }
    }, [signType, dataWithFilters, horizontalSignTypes])

    if (dataWithFiltersError || dataWithoutConditionFiltersError || isErrorHorizontalSignTypes) {
        return null
    }

    if (dataWithFiltersLoading || dataWithoutConditionFiltersLoading || isLoadingHorizontalSignTypes) {
        return <CatalogItemsCountSkeleton className={className} isMainCount={isMainCount} />
    }

    return <CatalogItemsCount
        className={className}
        filteredCount={calculatedCount}
        isMainCount={isMainCount}
        totalCount={displayTotalCount && dataWithoutConditionFilters?.count?.[signType]}
    />
}

HorizontalSignsCount.propTypes = {
    className: PropTypes.string,
    displayTotalCount: PropTypes.bool,
    isMainCount: PropTypes.bool,
    signType: PropTypes.string,
}